__turbopack_context__.v({
  "layout": "wyo0Ea_layout",
  "menuClosed": "wyo0Ea_menuClosed",
  "menuOpen": "wyo0Ea_menuOpen",
  "site": "wyo0Ea_site",
  "slide-in": "wyo0Ea_slide-in",
  "slide-out": "wyo0Ea_slide-out",
});
